<template>
  <div class="pb-4">
    <h1 class="h1">{{ trans('auth.reset_password.title') }}</h1>
    <p class="py-1">{{ trans('auth.reset_password.intro') }}</p>
  </div>

  <form @submit.prevent="submit">
    <form-input id="email-field"
                type="email"
                name="email"
                container-class="form-group"
                v-model="form.email"
                :error="form.errors.email"
                :label-text="trans('common.email')"
                :placeholder="trans('common.email')"
                autofocus
                required/>

    <form-input id="password-field"
                type="password"
                name="password"
                container-class="form-group"
                v-model="form.password"
                :error="form.errors.password"
                :label-text="trans('common.password')"
                :placeholder="trans('common.password')"
                autocomplete="new-password"
                required/>

    <form-input id="password_confirmation-field"
                type="password"
                name="password_confirmation"
                container-class="form-group"
                v-model="form.password_confirmation"
                :error="form.errors.password_confirmation"
                :label-text="trans('common.confirm_password')"
                :placeholder="trans('common.confirm_password')"
                autocomplete="new-password"
                required/>

    <div class="flex items-center justify-end mt-4">
      <form-button :value="trans('auth.reset_password.title')" :processing="form.processing"/>
    </div>

    <div class="flex justify-content-between align-items-center mt-4 pt-4 border-top">
      <div>
        {{ trans('auth.reset_password.remember_password') }}
        <inertia-link class="btn btn-link font_bold" :href="localeRoute('login')" v-text="trans('auth.login.title')"/>
      </div>

      <language-toggle :route-to="{name: 'password.reset', params: {token: props.token}, query: {email: props.email}}"/>
    </div>
  </form>
</template>

<script>
import AuthLayout from "@/Layouts/AuthLayout";

export default {
  layout: AuthLayout
}
</script>

<script setup>
import {useForm} from "@inertiajs/vue3";
import LanguageToggle from "@/components/Shared/LanguageToggle";
import FormInput from "@/components/Shared/Form/Input/Index";
import FormButton from "@/components/Shared/Form/Button";
import {useLocales} from "@/composables/locales";

const props = defineProps({
  token: String,
  email: String,
})

const localeRoute = useLocales().localeRoute

const form = useForm({
  token: props.token,
  email: props.email,
  password: '',
  password_confirmation: ''
})

const submit = () => {
  form.post(localeRoute('password.update'), {
    onFinish: () => form.reset('password', 'password_confirmation'),
  });
}
</script>
